import { Component, inject, OnInit } from '@angular/core';
import { AuthHelperService } from '../../services';

@Component({
  selector: 'app-auth',
  imports: [],
  templateUrl: './auth.html',
  styleUrl: './auth.scss',
})

export class Auth implements OnInit {

  private authServiceHelper =                                              inject(AuthHelperService);

  ngOnInit(): void {

    this.authServiceHelper.initializeAuthFlow(); 
  }

  logout(): void {

    this.authServiceHelper.logout();
  }
}
